/**
 * Descriptive SEO alt texts for all JG Mesterbyg image assets
 */
export const IMAGE_DESCRIPTIONS = {
  "toemrer-jg-mesterbyg-erslev-mors.jpg": "Håndværker fra JG Mesterbyg ved firmabil i Erslev på Mors",
  "koekkenrenovering-beige-elementer-traegulv.jpg": "Moderne køkkenrenovering med beige skabe, integrerede hvidevarer og lyst trægulv",
  "montering-hvide-vinduer-og-terrassedoer.jpg": "Nymonterede hvide energivinduer og terrassedør i træfacade på Mors",
  "garage-vaerksted-osb-plader-ledhejseport.jpg": "Indvendig isolering og vægbeklædning med OSB-plader i værksted og garage",
  "jg-mesterbyg-firmabiler-erslev.jpg": "JG Mesterbyg firmabiler parkeret foran værkstedsbygninger på Mors",
  "traeskelet-byggeri-stillads-nybyg.jpg": "Opbygning af bærende træskelet og stillads til nybyggeri og tilbygning",
  "tagrenovering-roedstenshus-tagsten-tagvinduer.jpg": "Tagrenovering på rødstenshus med nye mørke tagsten og monterede tagvinduer",
  "montering-nyt-tag-laegter-landejendom.jpg": "Tømrer monterer nye taglægter og tag på landejendom fra stillads",
  "tagarbejde-stillads-murstensbygning.jpg": "Renovering af tag og facade med stillads på murstensbygning i Nordjylland",
  "opsaetning-gipsplader-skillevaegge-renovering.jpg": "Opsætning af gipsplader og skillevægge under indendørs boligrenovering",
  "laegtning-tagkonstruktion-stillads.jpg": "Tømrerarbejde med lægtning og tagkonstruktion på byggeplads",
  "akustikloft-traebeton-renoveret-rum.jpg": "Nyistandsat stue med monteret akustikloft af træbeton og mørkt gulv",
  "nyt-tag-jg-mesterbyg.jpg": "Moderne hus med nylagt mørkt skifertag udført af tømrer",
  "renovering-jg-mesterbyg.jpg": "Tømrer udfører præcisionsarbejde ved boligrenovering i Nordjylland",
  "koekkenrenovering-jg-mesterbyg.jpg": "Eksklusiv køkkenrenovering med egetræselementer og lys bordplade",
  "solceller-jg-mesterbyg.jpg": "Montering af sorte solcellepaneler på tag med renoveret klimaskærm",
  "vinduer-doere-jg-mesterbyg.jpg": "Nye energirigtige trævinduer og døre monteret på murstenshus",
  "logo-jg-mesterbyg-removebg-preview.png": "JG Mesterbyg logo - Professionel tømrermester på Mors",
  "logo-jg-mesterbyg.png": "JG Mesterbyg logo - Professionel tømrermester på Mors",
  "ikon-jg-mesterbyg.png": "JG Mesterbyg ikon",
  "ikon-jg-mesterbyg-removebg-preview.png": "JG Mesterbyg cirkulært ikon"
};

/**
 * Returns a relevant, descriptive Danish alt text for any image URL or file name
 */
export function getImageAlt(imageUrl, fallbackContext = "JG Mesterbyg tømrerarbejde") {
  if (!imageUrl) return fallbackContext;
  
  // Extract filename
  const cleanUrl = String(imageUrl).split("?")[0];
  const filename = cleanUrl.substring(cleanUrl.lastIndexOf("/") + 1);
  
  if (IMAGE_DESCRIPTIONS[filename]) {
    return IMAGE_DESCRIPTIONS[filename];
  }

  // Check if filename contains recognizable keywords
  for (const [key, desc] of Object.entries(IMAGE_DESCRIPTIONS)) {
    if (filename.includes(key) || key.includes(filename)) {
      return desc;
    }
  }

  return `${fallbackContext} - Håndværk udført af JG Mesterbyg`;
}
